import AssignmentIcon from '@material-ui/icons/Assignment';
import BrightnessFourIcon from '@material-ui/icons/Brightness4';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import GetAppIcon from '@material-ui/icons/GetApp';
import HistoryIcon from '@material-ui/icons/History';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../../application-core/constants';
import ComponentBody from '../../core/ComponentBody';
import ComponentDetail from '../../core/ComponentDetail';
import HistoryViewer from '../../core/HistoryViewer';
import HierarchyIcon from '../../core/icons/Hierarchy';
import InAppBar from '../../core/InAppBar';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import TripleViewer from '../../core/TripleViewer';
import withGS from '../../core/withGShoc';
import SchemeExport from './SchemeExport';
import SchemeQuality from './SchemeQuality';
import SchemeStatistics from './SchemeStatistics';
import Suggestions from './Suggestions';
import LifeCycle from './Lifecycle';

const defaultAppBarItems = [
  {
    icon: HierarchyIcon,
    label: "Detail"
  },
  {
    icon: LinearScaleIcon,
    label: "Triples"
  },
  {
    icon: HistoryIcon,
    label: "History"
  },
  {
    icon: InsertChartIcon,
    label: "Statistics"
  },
  {
    icon: AssignmentIcon,
    label: "Quality"
  },
  {
    icon: GetAppIcon,
    label: "Export"
  },
  {
    icon: BrightnessFourIcon,
    label: "Lifecycle"
  }
];

class TaxonomyData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  toggleTaxonomyDetail = () => this.props.toggleTaxonomyDetail(1);

  render() {

    const { id, data, projectIRI, graph, entitlements } = this.props;
    const { view } = this.state;
    const taxonomyLink = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy#project=' + projectIRI + "&taxonomy=" + id;
    const maxWidth = [800, null, null, null, null, null, null, null][view];

    let tabItems = [...defaultAppBarItems];
    if (entitlements.includes(ENTITLEMENTS.VIEW_SUGGESTIONS) || entitlements.includes(ENTITLEMENTS.MAKE_SUGGESTIONS) || entitlements.includes(ENTITLEMENTS.MANAGE_SUGGESTIONS)) {
      tabItems.push({
        icon: EmojiObjectsIcon,
        label: "Suggestions"
      });
    }
    const appBar = <InAppBar
      tabValue={view}
      onChangeTab={this.changeView}
      tabItems={tabItems} />;

    return (
      <ProjectConsumer>
        {({ defaultLang, ontologyProjectAssociation, skosXL, hasComponent }) => (
          <ComponentBody maxWidth={maxWidth} title={data.title} id={data.id} onToggleView={this.toggleTaxonomyDetail} appBar={appBar}>
            {view === 0 && <ComponentDetail
              id={id}
              graph={graph}
              iriOptions={["showIRI"]}
              entitlements={entitlements}
              baseInferredClass="http://www.w3.org/2004/02/skos/core#ConceptScheme"
              associatedProject={data.associatedProject ?
                Array.isArray(data.associatedProject) ?
                  data.associatedProject
                  :
                  [data.associatedProject]
                :
                []
              }
              entitlement={ENTITLEMENTS.EDIT_TAXONOMY}
              includeAdditionalMetadata={true}
              includeTemplates={true}
              includeLinkedResources={true}
              includeWorkflow={true}
              includeNotes={true}
              canHideProps={
                [
                  {
                    label: "Hidden Label",
                    property: "http://www.w3.org/2004/02/skos/core#hiddenLabel"
                  },
                  {
                    label: "Broad Match",
                    property: "http://www.w3.org/2004/02/skos/core#broadMatch"
                  },
                  {
                    label: "Close Match",
                    property: "http://www.w3.org/2004/02/skos/core#closeMatch"
                  },
                  {
                    label: "Exact Match",
                    property: "http://www.w3.org/2004/02/skos/core#exactMatch"
                  },
                  {
                    label: "Narrow Match",
                    property: "http://www.w3.org/2004/02/skos/core#narrowMatch"
                  },
                  {
                    label: "Related Match",
                    property: "http://www.w3.org/2004/02/skos/core#relatedMatch"
                  },
                  {
                    label: "Notation",
                    property: "http://www.w3.org/2004/02/skos/core#notation"
                  }, {
                    label: "Change Note",
                    property: "http://www.w3.org/2004/02/skos/core#changeNote"
                  },
                  {
                    label: "Definition",
                    property: "http://www.w3.org/2004/02/skos/core#definition"
                  },
                  {
                    label: "Editorial Note",
                    property: "http://www.w3.org/2004/02/skos/core#editorialNote"
                  },
                  {
                    label: "Example",
                    property: "http://www.w3.org/2004/02/skos/core#example"
                  },
                  {
                    label: "History Note",
                    property: "http://www.w3.org/2004/02/skos/core#historyNote"
                  },
                  {
                    label: "Scope Note",
                    property: "http://www.w3.org/2004/02/skos/core#scopeNote"
                  },
                  {
                    label: "Top Concept Of",
                    property: "http://www.w3.org/2004/02/skos/core#topConceptOf"
                  }
                ]}
              includeXL={skosXL}
              includeEditingMode={true}
              includeClasses={true}
              includeSlashHash={true} />
            }
            {view === 1 && <TripleViewer id={id} graph={graph} displayTitle={false} />}
            {view === 2 && <HistoryViewer
              id={id}
              options={[
                {
                  label: "Concept Scheme Only",
                },
                {
                  label: "All Resources In Scheme",
                  resource: true,
                  path: "http://www.w3.org/2004/02/skos/core#inScheme"
                }
              ]}
              graph={graph}
              onToggleView={this.toggleTaxonomyDetail}
              displayTitle={false} />}
            {view === 3 && <SchemeStatistics
              id={id}
              workflow={data.activateWorkflow === true}
              graph={graph} />}
            {view === 4 && <SchemeQuality
              id={id}
              skosXL={skosXL || false}
              data={data}
              link={taxonomyLink}
              graph={graph}
              onToggleView={this.toggleTaxonomyDetail}
              ontologyProjectAssociation={ontologyProjectAssociation} />}
            {view === 5 && <SchemeExport
              id={id}
              graph={graph}
              skosXL={skosXL || false}
              examples={data.hasTopConcept ? data.hasTopConcept.slice(0, 3) : []}
              defaultLang={defaultLang}
              entitlements={entitlements}
              ontologyProjectAssociation={ontologyProjectAssociation} />}
            {view === 6 && <LifeCycle
              id={id}
              graph={graph}
              defaultLang={defaultLang}
              entitlements={entitlements}
              skosXL={skosXL || false}
              useWorkflow={data.activateWorkflow === true}
              onToggleView={this.toggleTaxonomyDetail}
              components={hasComponent}
              projectIRI={projectIRI}
              componentIRI={id} />}
            {view === 7 && <Suggestions
              id={id}
              graph={graph}
              components={hasComponent}
              defaultLang={defaultLang}
              onToggleView={this.toggleTaxonomyDetail}
              projectIRI={projectIRI}
              schemeIRI={id} />}
          </ComponentBody>
        )}
      </ProjectConsumer>
    );
  }
}

TaxonomyData.propTypes = {
  data: PropTypes.object.isRequired,
  entitlements: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  projectIRI: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  toggleTaxonomyDetail: PropTypes.func.isRequired
};

export default withRouter(withGS(TaxonomyData));